export default __webpack_public_path__ + "static/media/logo.d1882966.png";